<script setup lang="ts">
import * as commonConstants from '@/constants/common';
</script>

<template>
  <div :class="$style.kInfoWrapper" data-testid="kInfoWrapper">
    <div :class="$style.headerWrapper">
      <slot name="header">{{ commonConstants.EM_DASH }}</slot>
    </div>
    <div :class="$style.main">
      <slot>{{ commonConstants.EM_DASH }}</slot>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.kInfoWrapper {
  line-height: 1.4;
  border: 1px solid colors.$color-gray-300;
  border-radius: 4px;
}
  .headerWrapper {
    background-color: colors.$color-gray-100;
    padding: 6px 16px;
    min-height: 36px;
    display: flex;
    align-items: center;
  }
  .main {
    padding: 16px;
  }
</style>
